import BaseSelect from 'lib/BaseSelect';
import { Label } from 'lib/Label';
import BaseSelectOption from 'lib/BaseSelect/BaseSelectOption';
import { BaseSelectOptionProps } from 'lib/BaseSelect/BaseSelect.types';
import { OptionProps } from 'react-select';
import usePendoTracking from 'customHooks/usePendoTracking';
import { MetricOption, MetricType } from 'components/common/types/DrilldownReports.types';
import { metricTypeToName } from 'components/common/DrilldownReports/consts';
import { UseAllocationReport } from '../useAllocationReport';

interface DropdownMetricProps
  extends Pick<ReturnType<UseAllocationReport>, 'handleChangeMetricType' | 'selectedMetricType'> {
  availableMetricOptions: MetricOption[];
}

export const DropdownMetric: React.FC<DropdownMetricProps> = ({
  handleChangeMetricType,
  selectedMetricType,
  availableMetricOptions,
}) => {
  const { getPendoDataId } = usePendoTracking();

  return (
    <div className="flex flex-col min-w-36 w-full md:w-36" data-dd-action-name="Allocation report / Metric dropdown">
      <Label label="Metrics" />
      <BaseSelect
        dataTestId="metrics"
        name="Metrics"
        selectedValue={{ code: selectedMetricType, name: metricTypeToName[selectedMetricType] }}
        onSelect={(_, value: { code: MetricType; name: string }) => handleChangeMetricType(value.code)}
        options={availableMetricOptions}
        customComponents={{
          Option: ({
            isSelected,
            innerRef,
            innerProps,
            children,
            data,
          }: BaseSelectOptionProps & OptionProps<MetricOption>) => {
            return (
              <BaseSelectOption
                isMultiple={false}
                optionControl="radio"
                isSelected={isSelected}
                innerRef={innerRef}
                innerProps={innerProps}
                data={data}
                dataPendoId={getPendoDataId(`Allocation metric ${data.name} option`)}
              >
                {children}
              </BaseSelectOption>
            );
          },
        }}
        withPortal={false}
      />
    </div>
  );
};
